import qs from 'query-string';
import { get, post, put, del } from '../baseApi';

export const UserApi = {
    fetch: (query) => get(`/admin/users?${qs.stringify(query)}`),
    fetchById: (id) => get(`/admin/users/${id}`),
    create: (data) => post('/admin/users', data),
    update: (id, data) => put(`/admin/users/${id}`, data),
    delete: (id) => del(`/admin/users/${id}`),
};
